import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { trialsCrudStateConfig } from "../../../consts";

const trialsMetaReducer = makeCrudStateReducer(trialsCrudStateConfig);

export default trialsMetaReducer;
